/** Spanish for the estimate builder's forms (ADR 0325); see index.ts. The invoice, proposal wording and orders stay English. */
export const estimateForms: Readonly<Record<string, string>> = {
  Saved: "Guardado",
  "Creating…": "Creando…",
  Active: "Activo",
  "Changes save on their own.": "Los cambios se guardan solos.",
  Discount: "Descuento",
  "Select Color": "Elegir color",
  "What the customer sees as the heading":
    "Lo que el cliente ve como encabezado",
  "this area": "esta área",
  "this sub": "este subcontratista",
  "Scope of Work": "Alcance del trabajo",
  Packages: "Paquetes",
  "Pick a package": "Elegir un paquete",
  "No {material} package is built out yet. Build one under Tools → Templates.":
    "Todavía no hay ningún paquete de {material} armado. Arma uno en Herramientas → Plantillas.",
  "Saves as you go. Everything here goes to QuickBooks except the note.":
    "Se guarda mientras escribes. Todo lo de aquí va a QuickBooks menos la nota.",
  "Tracking Number": "Número de referencia",
  "Invoice or receipt reference": "Referencia de la factura o del recibo",
  "Agreed with the customer — kept out of the added-after-scheduling figure.":
    "Acordado con el cliente — no cuenta en la cifra de agregados después de programar.",
  "Counts as something the estimate missed.":
    "Cuenta como algo que al presupuesto se le pasó.",
  "How this figure was arrived at. Internal only.":
    "Cómo se llegó a esta cifra. Solo para uso interno.",
  "Open {title}": "Abrir {title}",
  "Receipt {n}": "Recibo {n}",
  "Upload a receipt for this expense. It is kept here and on the job's Docs card.":
    "Subir un recibo para este gasto. Se guarda aquí y en la tarjeta de Documentos del trabajo.",
  "+ Receipt": "+ Recibo",
  "Add receipt": "Agregar recibo",
  "Receipt file": "Archivo del recibo",
  "The whole job": "El trabajo completo",
  "Every active option on this job, added up. The figures above are the one estimate on screen.":
    "Todas las opciones activas de este trabajo, sumadas. Las cifras de arriba son solo del presupuesto en pantalla.",
  Option: "Opción",
  "shown above": "mostrado arriba",
  "Whole job": "Trabajo completo",
  "Stop budgeting a crane on this estimate":
    "Dejar de presupuestar una grúa en este presupuesto",
  "Budget a crane — $276 an hour, 8 hours a day minimum, plus 9% fuel and 12% miscellaneous":
    "Presupuestar una grúa — $276 por hora, mínimo 8 horas al día, más 9% de combustible y 12% de gastos varios",
  "Days of crane": "Días de grúa",
  "days — leave blank to work it out from the roof":
    "días — deja en blanco para calcularlos según el techo",
  " ({squares} squares → {days} days)": " ({squares} cuadros → {days} días)",
  " (no roof measured yet)": " (todavía no hay techo medido)",
  "How is this roof finished?": "¿Qué acabado lleva este techo?",
  Finish: "Acabado",
  Painted: "Pintado",
  Galvalume: "Galvalume",
  "Panels, trim, ridge cap and stitch screws all color matched, plus touch-up paint.":
    "Paneles, molduras, cumbrera y tornillos de costura en el mismo color, más pintura para retoques.",
  "Bare galvalume throughout — trim and fasteners to match, and no touch-up paint.":
    "Galvalume sin pintar en todo — molduras y tornillos a juego, y sin pintura para retoques.",
  "Furring strips over the existing roof":
    "Listones de madera sobre el techo existente",
  'Adds the strips, the framing nails and the labor to install them, and the panels take a 2" screw.':
    'Agrega los listones, los clavos de armazón y la mano de obra para instalarlos, y los paneles llevan tornillo de 2".',
  'Panels fasten straight to the deck with a 1 1/2" screw. No strips, nails or furring labor.':
    'Los paneles se fijan directo al entablado con tornillo de 1 1/2". Sin listones, clavos ni mano de obra de listones.',
  "Choose…": "Elegir…",
  "Another colour…": "Otro color…",
  "{label}, typed": "{label}, escrito a mano",
  "Type the colour": "Escribe el color",
  "What does this house get?": "¿Qué lleva esta casa?",
  "Tear off the existing siding": "Quitar el revestimiento existente",
  "The crew's tear-off rate replaces the layover rate, and a dump trailer goes on the work order per 13 squares coming off.":
    "La tarifa de demolición de la cuadrilla reemplaza la de sobrepuesto, y va un remolque de escombro en la orden de trabajo por cada 13 cuadros que se quitan.",
  "A layover: the new siding goes over what is there, and the crew is paid the layover rate per square to hang it.":
    "Sobrepuesto: el revestimiento nuevo va encima del existente, y a la cuadrilla se le paga la tarifa de sobrepuesto por cuadro para colocarlo.",
  "Wrap the windows and doors": "Forrar ventanas y puertas",
  "Replace the soffit with vinyl": "Reemplazar el sofito con vinilo",
  "Wrap the fascia": "Forrar la fascia",
  "Wrap the frieze board": "Forrar la tabla de friso",
  "Each adds its materials and its charge — per opening for the wraps, by the foot for the soffit, fascia and frieze — and is said in the scope of work.":
    "Cada uno agrega sus materiales y su cargo — por abertura en los forros, por pie en el sofito, la fascia y el friso — y se menciona en el alcance del trabajo.",
  "Siding colour": "Color del revestimiento",
  "Goes on the panels on the material order.":
    "Va en los paneles de la orden de materiales.",
  "Trim colour": "Color de las molduras",
  "Corners, J channel, vents and blocks. Often white.":
    "Esquinas, canal J, ventilas y bloques. Casi siempre blanco.",
  "How many of each?": "¿Cuántos de cada uno?",
  "Counted on the house, not by the report. The vents start at Hover’s count; the rest at none.":
    "Contados en la casa, no según el reporte. Las ventilas empiezan con el conteo de Hover; el resto en cero.",
  "Octagon gable vents": "Ventilas de hastial octagonales",
  "Rectangle gable vents": "Ventilas de hastial rectangulares",
  "Light blocks (mount masters)": "Bloques para luces (mount masters)",
  "Split blocks (pipes and wires)": "Bloques partidos (tubos y cables)",
  "Hooded dryer vents": "Ventilas de secadora con capucha",
  "No siding area is measured on this job, so the panels, house wrap and the crew's install come out at nothing.":
    "Este trabajo no tiene área de revestimiento medida, así que los paneles, la envoltura de la casa y la instalación de la cuadrilla salen en cero.",
  "Windows and doors are to be wrapped, but none are counted on the wall measurement.":
    "Se van a forrar ventanas y puertas, pero no hay ninguna contada en la medida de paredes.",
  "Soffit is to be replaced, but no soffit length is measured.":
    "Se va a reemplazar el sofito, pero no hay largo de sofito medido.",
  "Fascia is to be wrapped, but no fascia length is measured.":
    "Se va a forrar la fascia, pero no hay largo de fascia medido.",
  "Frieze board is to be wrapped, but no frieze length is measured.":
    "Se va a forrar la tabla de friso, pero no hay largo de friso medido.",
  "How big is the deck?": "¿De qué tamaño es el deck?",
  "Width along the house (ft)": "Ancho a lo largo de la casa (pies)",
  "Depth out from the house (ft)": "Fondo desde la casa (pies)",
  "{area} square feet. The crew is paid on this, and the customer reads it.":
    "{area} pies cuadrados. A la cuadrilla se le paga sobre esto, y el cliente lo lee.",
  "The square feet are worked out from these two.":
    "Los pies cuadrados se calculan con estos dos.",
  "Height off the ground (ft)": "Altura sobre el suelo (pies)",
  "Sets how long the posts are and how many steps down.":
    "Define el largo de los postes y cuántos escalones bajan.",
  "Second-story deck": "Deck de segundo piso",
  "Replacing a deck": "Reemplazo de un deck",
  "The crew is paid the second-story rate.":
    "A la cuadrilla se le paga la tarifa de segundo piso.",
  "The crew is paid the one-story rate.":
    "A la cuadrilla se le paga la tarifa de un piso.",
  "The scope says the old deck is torn down and hauled away first.":
    "El alcance dice que primero se demuele y se retira el deck viejo.",
  "A new deck: the scope says nothing is torn down.":
    "Deck nuevo: el alcance dice que no se demuele nada.",
  "Fastened to the house": "Sujeto a la casa",
  "A ledger board on the house, flashed, with tension ties; one row of posts at the front.":
    "Una viga de apoyo en la casa, con tapajuntas y amarres de tensión; una fila de postes al frente.",
  "Freestanding: a row of posts at the front and the back, and no ledger.":
    "Independiente: una fila de postes al frente y otra atrás, sin viga de apoyo.",
  "Steps and railing": "Escalones y barandal",
  "Sets of steps": "Juegos de escalones",
  "The first set is in the crew’s rate; each one after it is charged on its own.":
    "El primer juego va en la tarifa de la cuadrilla; cada uno después se cobra aparte.",
  "Width of each set (ft)": "Ancho de cada juego (pies)",
  "Railing required": "Lleva barandal",
  "Railing (ft)": "Barandal (pies)",
  "Every open side, less the stair openings. Change it if a side has none.":
    "Todos los lados abiertos, menos las aberturas de los escalones. Cámbialo si algún lado no lleva.",
  "The open sides come to {ft} ft.": "Los lados abiertos suman {ft} pies.",
  "The steps get handrails on both sides on top of this.":
    "Los escalones llevan pasamanos a ambos lados, aparte de esto.",
  "No railing round the deck, and no handrails on the steps.":
    "Sin barandal alrededor del deck y sin pasamanos en los escalones.",
  "The deck has no width or depth, so nothing is ordered and the crew is paid nothing.":
    "El deck no tiene ancho ni fondo, así que no se pide nada y a la cuadrilla no se le paga nada.",
  "The deck is more than 16 ft up. No post that long is stocked — price a two-storey deck with stacked posts by hand.":
    "El deck está a más de 16 pies de altura. No hay postes tan largos en existencia — cotiza a mano un deck de dos pisos con postes apilados.",
  "The steps run more than 16 ft, which needs a landing. Check the stringers by hand.":
    "Los escalones recorren más de 16 pies, lo que requiere un descanso. Revisa las zancas a mano.",
  "The deck is 30 inches or more off the ground, and railing is not ticked. Code wants a guard rail on every open side.":
    "El deck está a 30 pulgadas o más del suelo y el barandal no está marcado. El código exige barandal en cada lado abierto.",
  "Gross Profit Margin": "Margen de ganancia bruta",
  "Set the margin and the line items are repriced to match. Change orders and discounts are left as they are.":
    "Fija el margen y las líneas se vuelven a cotizar para cuadrar. Las órdenes de cambio y los descuentos se quedan igual.",
  "Repricing…": "Recotizando…",
  Reprice: "Recotizar",
  "Down one percent": "Bajar uno por ciento",
  "Gross profit margin": "Margen de ganancia bruta",
  "Up one percent": "Subir uno por ciento",
  "Contract now": "Contrato ahora",
  Becomes: "Queda en",
  "Goes up by": "Sube",
  "Comes down by": "Baja",
  "1 line repriced — currently at {pct}.":
    "1 línea recotizada — actualmente en {pct}.",
  "{n} lines repriced — currently at {pct}.":
    "{n} líneas recotizadas — actualmente en {pct}.",
  "A margin has to be between 0 and 100.":
    "El margen tiene que estar entre 0 y 100.",
  "Use {pct}%": "Usar {pct}%",
  "There is nothing to reprice yet — add a line item first.":
    "Todavía no hay nada que recotizar — agrega una línea primero.",
  "Every line on this estimate is $0. Price the work first, and the margin will move it.":
    "Todas las líneas de este presupuesto están en $0. Ponle precio al trabajo primero, y el margen lo moverá.",
  "The change orders already on this estimate come to more than any margin leaves room for. Take one of them off first.":
    "Las órdenes de cambio que ya tiene este presupuesto suman más de lo que cualquier margen permite. Quita una primero.",
  "How is this roof built?": "¿Cómo se construye este techo?",
  "New construction — nothing to tear off or roof over":
    "Construcción nueva — nada que quitar ni que cubrir",
  "TPO flute fill over a metal deck":
    "Relleno de canales TPO sobre entablado metálico",
  "Each layer is another $20 a square to the crew, and it sizes the dumpster.":
    "Cada capa son $20 más por cuadro para la cuadrilla, y define el tamaño del contenedor.",
  Insulation: "Aislamiento",
  '1" ISO': 'ISO de 1"',
  '1.5" ISO': 'ISO de 1.5"',
  '2.2" ISO': 'ISO de 2.2"',
  '2.6" ISO': 'ISO de 2.6"',
  '1/2" high-density ISO': 'ISO de alta densidad de 1/2"',
  '1" high-density ISO': 'ISO de alta densidad de 1"',
  '1/2" fiberboard coverboard': 'Tablero de fibra de 1/2"',
  "2 layers": "2 capas",
  "Securock coverboard over the ISO": "Tablero Securock sobre el ISO",
  "Insulation is": "El aislamiento va",
  "Mechanically attached — screwed through metal or wood deck":
    "Fijado mecánicamente — atornillado al entablado de metal o madera",
  "Adhered — glued, for a concrete deck you cannot screw":
    "Adherido — pegado, para losa de concreto donde no se puede atornillar",
  "Membrane is": "La membrana va",
  "Mechanically fastened": "Fijada mecánicamente",
  "Fully adhered": "Totalmente adherida",
  "Screw length": "Largo del tornillo",
  'inches — has to pass the deck and come out 1" the far side, and on metal decking that is 1" past the low rib.':
    'pulgadas — tiene que atravesar el entablado y salir 1" del otro lado, y en entablado metálico eso es 1" después de la nervadura baja.',
  "Insulation up the parapet walls as well as the roof":
    "Aislamiento en los muros de parapeto además del techo",
  "Terminated with": "Terminado con",
  "Termination bar": "Barra de terminación",
  "Kynar drip edge (adds cover tape and primer)":
    "Goterón Kynar (agrega cinta de cubierta e imprimador)",
  "TPO coated metal (heat welded, no tape or primer)":
    "Metal recubierto de TPO (soldado con calor, sin cinta ni imprimador)",
  "Bar fastens into": "La barra se fija en",
  'Masonry — 1/4" x 1-1/2" masonry anchors':
    'Mampostería — anclas para mampostería de 1/4" x 1-1/2"',
  'Wood — 1-1/4" metal to wood screws':
    'Madera — tornillos de metal a madera de 1-1/4"',
  "Drip edge girth": "Desarrollo del goterón",
  "inches, every bend added up.": "pulgadas, sumando cada doblez.",
  "Coping on the parapet walls": "Albardilla en los muros de parapeto",
  "Coping girth": "Desarrollo de la albardilla",
  "Scuppers — adds a sheet of TPO coated metal":
    "Gárgolas — agrega una lámina de metal recubierto de TPO",
  "Versico job — uses the Versico membrane, adhesive and fasteners":
    "Trabajo Versico — usa la membrana, el adhesivo y los sujetadores Versico",
  "1 strip per 4x10 sheet, {feet} feet.":
    "1 tira por lámina de 4x10, {feet} pies.",
  "{n} strips per 4x10 sheet, {feet} feet.":
    "{n} tiras por lámina de 4x10, {feet} pies.",
  "The insulation is glued but the membrane is screwed. Insulation is usually glued because the deck is concrete and cannot be screwed into — in which case the membrane cannot be either.":
    "El aislamiento va pegado pero la membrana atornillada. El aislamiento suele pegarse porque la losa es de concreto y no se puede atornillar — y en ese caso la membrana tampoco.",
  "This job has no roof area measured, so nothing bought by the square will be ordered — no membrane, insulation, adhesive or fasteners. Add the area on the measurement screen first.":
    "Este trabajo no tiene área de techo medida, así que no se pedirá nada que se compre por cuadro — ni membrana, aislamiento, adhesivo ni sujetadores. Agrega el área en la pantalla de medidas primero.",
  "Coping is ticked but no parapet wall length is measured, so no coping metal and no coping labour will be ordered. Add the parapet wall feet on the measurement screen.":
    "La albardilla está marcada pero no hay largo de muro de parapeto medido, así que no se pedirá ni el metal ni la mano de obra de albardilla. Agrega los pies de muro de parapeto en la pantalla de medidas.",
  "our own people — both policies are ours":
    "nuestra propia gente — las dos pólizas son nuestras",
  "carries their own liability": "tiene su propia responsabilidad civil",
  "no liability of their own": "sin responsabilidad civil propia",
  "no liability certificate on file — budgeted as if they have none":
    "sin certificado de responsabilidad civil en archivo — presupuestado como si no tuviera",
  "carries their own comp": "tiene su propio seguro de trabajadores",
  "we carry their comp": "nosotros cubrimos su seguro de trabajadores",
  "no comp certificate on file — budgeted as if they have none":
    "sin certificado de seguro de trabajadores en archivo — presupuestado como si no tuviera",
  "Sub to budget insurance for":
    "Subcontratista para el que se presupuesta el seguro",
  "Choose a sub…": "Elegir un subcontratista…",
  "An expense": "Un gasto",
  "Every sub already has a line on this estimate":
    "Todos los subcontratistas ya tienen una línea en este presupuesto",
  "Worked out from what the sub is paid, at the rates on the policy":
    "Calculado según lo que se le paga al subcontratista, con las tasas de la póliza",
  "General Liability for a sub": "Responsabilidad civil para un subcontratista",
  "Workers Comp for a sub": "Seguro de trabajadores para un subcontratista",
  "Sub this insurance is for": "Subcontratista de este seguro",
  "Labour for {sub}": "Mano de obra de {sub}",
  "of labour": "de mano de obra",
  "Trade for {sub}": "Oficio de {sub}",
  "Stop budgeting insurance for this sub":
    "Dejar de presupuestar el seguro de este subcontratista",
  "Remove insurance for {sub}": "Quitar el seguro de {sub}",
  "Is any part of this roof a different material?":
    "¿Alguna parte de este techo es de otro material?",
  "Part of this roof is metal, TPO or something else":
    "Parte de este techo es de metal, TPO u otra cosa",
  "A metal porch, a flat dormer, a lean-to. Describe it and it is priced as itself — and taken off the roof the packages above are worked out from, so the same square is never sold twice.":
    "Un porche de metal, una buhardilla plana, un cobertizo. Descríbelo y se cotiza por separado — y se descuenta del techo con el que se calculan los paquetes de arriba, para no vender dos veces el mismo cuadro.",
  "The parts of this roof in another material":
    "Las partes de este techo en otro material",
  "Area name": "Nombre del área",
  "Front porch": "Porche delantero",
  "Material for {area}": "Material de {area}",
  "Package for {area}": "Paquete de {area}",
  "Measured out of": "Medido a partir de",
  "Which roof {area} is part of": "De qué techo forma parte {area}",
  "Add another area": "Agregar otra área",
  "The packages above will be generated from the rest of the roof — {squares} SQ, once {areas} is taken out.":
    "Los paquetes de arriba se generarán con el resto del techo — {squares} cuadros, una vez descontado {areas}.",
  "{area} ({squares} SQ)": "{area} ({squares} cuadros)",
  "Could not save the wording to {product}: {error}":
    "No se pudo guardar el texto en {product}: {error}",
  "Update Line Item": "Actualizar línea",
  "Saves as you go. The name and the scope are what the customer reads on the proposal.":
    "Se guarda mientras escribes. El nombre y el alcance son lo que el cliente lee en la propuesta.",
  "One-off work that is not in the catalogue — type the name, the trade, the scope and the price yourself.":
    "Trabajo único que no está en el catálogo — escribe tú mismo el nombre, el oficio, el alcance y el precio.",
  "The picker offers the products that carry a scope of work, because this is what the customer reads. Everything else is still on the material order, the work order and the other expenses.":
    "El selector ofrece los productos que tienen alcance del trabajo, porque esto es lo que el cliente lee. Todo lo demás sigue en la orden de materiales, la orden de trabajo y los otros gastos.",
  "{basis} — off this job's roof. Change the quantity if you counted it yourself.":
    "{basis} — según el techo de este trabajo. Cambia la cantidad si la contaste tú.",
  "The repair, as the customer reads it — “Chimney flashing rebuilt”":
    "La reparación, como la lee el cliente — “Tapajuntas de chimenea reconstruido”",
  "Custom repair — no product behind this line. Pick the trade above and put the price in Customer Price.":
    "Reparación personalizada — sin producto detrás de esta línea. Elige el oficio arriba y pon el precio en Precio al cliente.",
  "{amount} after discount. Type here to sell at a number and the unit price follows.":
    "{amount} después del descuento. Escribe aquí para vender a una cifra y el precio unitario se ajusta.",
  "The scope of work, as the customer reads it.":
    "El alcance del trabajo, como lo lee el cliente.",
  "Save this wording to {product}": "Guardar este texto en {product}",
  "Replaces what this product writes onto every future line.":
    "Reemplaza lo que este producto escribe en cada línea futura.",
  "This product has no wording yet. Saving it puts this scope on every future line.":
    "Este producto todavía no tiene texto. Al guardarlo, este alcance irá en cada línea futura.",
  "This scope carries protective clauses, and a product has nowhere to keep them — saving the wording would send every future line out without them. The clauses stay on this line.":
    "Este alcance lleva cláusulas de protección, y un producto no tiene dónde guardarlas — guardar el texto mandaría cada línea futura sin ellas. Las cláusulas se quedan en esta línea.",
  "Saved to the product. Lines already on other estimates are left as they are.":
    "Guardado en el producto. Las líneas que ya están en otros presupuestos se quedan igual.",
  Trigger: "Condición",
  "{label} is outside what the lender writes.":
    "{label} está fuera de lo que el prestamista acepta.",
  "Down payment": "Enganche",
  None: "Ninguno",
  "Term (months)": "Plazo (meses)",
  "Term in months": "Plazo en meses",
  "e.g. 120": "p. ej. 120",
  "Rate (APR %)": "Tasa (APR %)",
  "Rate as an annual percentage": "Tasa como porcentaje anual",
  "e.g. 11.9": "p. ej. 11.9",
  "The payment above is what this loan actually costs, and it is what the customer’s copy prints. A down payment comes off the amount financed only — it does not change the contract total, the deposit or the payment schedule.":
    "El pago de arriba es lo que realmente cuesta este préstamo, y es lo que se imprime en la copia del cliente. El enganche se descuenta solo del monto financiado — no cambia el total del contrato, el depósito ni el calendario de pagos.",
  "Leave the term and the rate empty and the proposal shows the old “about $13 per $1,000” figure instead of a real payment. The company’s own programme is set in Tools → Integrations.":
    "Deja el plazo y la tasa vacíos y la propuesta muestra la vieja cifra de “unos $13 por cada $1,000” en lugar de un pago real. El programa de la empresa se configura en Herramientas → Integraciones.",
  "A financing term needs a rate. Enter the rate, or clear the term.":
    "Un plazo de financiamiento necesita una tasa. Escribe la tasa o borra el plazo.",
  "A financing rate needs a term. Enter the term, or clear the rate.":
    "Una tasa de financiamiento necesita un plazo. Escribe el plazo o borra la tasa.",
  "The company's financing default in Tools has a term but no rate. Enter a rate on this estimate, or fix the default in Tools → Integrations.":
    "El financiamiento predeterminado de la empresa en Herramientas tiene plazo pero no tasa. Escribe una tasa en este presupuesto o corrige el predeterminado en Herramientas → Integraciones.",
  "The company's financing default in Tools has a rate but no term. Enter a term on this estimate, or fix the default in Tools → Integrations.":
    "El financiamiento predeterminado de la empresa en Herramientas tiene tasa pero no plazo. Escribe un plazo en este presupuesto o corrige el predeterminado en Herramientas → Integraciones.",
  "The customer pays us monthly instead of the Final in one go.":
    "El cliente nos paga mensualmente en lugar del pago final de una sola vez.",
  "Set up a payment plan": "Armar un plan de pagos",
  "Each month": "Cada mes",
  "Monthly payment": "Pago mensual",
  "First payment due": "Primer pago vence",
  "First monthly payment due": "Vencimiento del primer pago mensual",
  "Payment plan wording": "Texto del plan de pagos",
  "The customer reads this on the proposal.":
    "El cliente lee esto en la propuesta.",
  "Remove the payment plan": "Quitar el plan de pagos",
  "Type what the customer pays each month.":
    "Escribe lo que el cliente paga cada mes.",
  "Pick the date the first monthly payment is due.":
    "Elige la fecha en que vence el primer pago mensual.",
  "There is nothing left to pay monthly after the down payment.":
    "No queda nada por pagar mensualmente después del enganche.",
  "Payment {n}": "Pago {n}",
  "Payment Schedule": "Calendario de pagos",
  "50% default": "50% predeterminado",
  "Under $1,000 there is no payment split — clear the First, Second and Third amounts.":
    "Debajo de $1,000 no hay división de pagos — borra los montos del primero, segundo y tercero.",
  "Under $1,000 — no deposit, nothing to collect at signing.":
    "Debajo de $1,000 — sin depósito, nada que cobrar al firmar.",
  "Financing is off for every job until Foundation Finance approves it. Turn it back on in Tools → Integrations.":
    "El financiamiento está apagado para todos los trabajos hasta que Foundation Finance lo apruebe. Vuelve a encenderlo en Herramientas → Integraciones.",
  "Payments as low as": "Pagos desde",
  "/month": "/mes",
  "Show financing": "Mostrar financiamiento",
  "Show on estimate": "Mostrar en el presupuesto",
  "Hide on estimate": "Ocultar en el presupuesto",
  "Tick at least one estimate to bill.":
    "Marca al menos un presupuesto para facturar.",
  "The figures for this invoice could not be read.":
    "No se pudieron leer las cifras de esta factura.",
  "Reading the selected estimates and job balance…":
    "Leyendo los presupuestos seleccionados y el saldo del trabajo…",
  "This estimate has no line items to bill.":
    "Este presupuesto no tiene líneas que facturar.",
  "This estimate adds up to nothing — there is no invoice to send.":
    "Este presupuesto suma cero — no hay factura que enviar.",
  "An invoice needs somebody to bill.":
    "Una factura necesita a alguien a quien facturar.",
  "Invoice {number} made — {amount}": "Factura {number} creada — {amount}",
  "A PDF the customer, a carrier or a GC can pay off.":
    "Un PDF que el cliente, una aseguradora o un contratista general puede pagar.",
  "Download the PDF again": "Descargar el PDF otra vez",
  "Making it…": "Creando…",
  "Make the invoice": "Crear la factura",
  "Already billed on this job": "Ya facturado en este trabajo",
  "Void invoice {number}?": "¿Anular la factura {number}?",
  "The document is kept — voiding records that it no longer stands.":
    "El documento se conserva — anularla deja registro de que ya no es válida.",
  "What to bill": "Qué facturar",
  " · open": " · abierto",
  "Bill to": "Facturar a",
  "Their email": "Su email",
  "Their address": "Su dirección",
  "Invoice date": "Fecha de la factura",
  Memo: "Memo",
  "What it will say — invoice {number}, due {date}":
    "Lo que dirá — factura {number}, vence {date}",
  "Received and balance are for the whole job ({contract}), which this invoice is part of.":
    "Lo recibido y el saldo son del trabajo completo ({contract}), del que esta factura es parte.",
  "{amount} of that balance has been paid and is still on its way to the bank.":
    "{amount} de ese saldo ya se pagó y todavía va en camino al banco.",
  "Invoice {number} is made and cannot be changed":
    "La factura {number} está creada y no se puede cambiar",
  "The estimate can carry on being edited without touching it. If it is wrong, void it and make another — the next one takes the next number.":
    "El presupuesto se puede seguir editando sin tocarla. Si está mal, anúlala y crea otra — la siguiente toma el siguiente número.",
  "Sent {date} to {to}": "Enviada {date} a {to}",
  "Sent {date}": "Enviada {date}",
  "Made {date} · not sent": "Creada {date} · sin enviar",
  " · due {date}": " · vence {date}",
  "Email invoice {number}": "Enviar por email la factura {number}",
  "The PDF goes with it.": "El PDF va adjunto.",
  "Your Gmail is not connected": "Tu Gmail no está conectado",
  "Nothing can be sent from here until it is — Tools → Integrations. The PDF can still be downloaded and attached from your own mail.":
    "No se puede enviar nada desde aquí hasta que lo esté — Herramientas → Integraciones. El PDF se puede descargar y adjuntar desde tu propio correo.",
  "Type the deck's width and depth first.":
    "Escribe primero el ancho y el fondo del deck.",
  "Type what the repair covers. It is what the customer signs for, and the repair contract promises nothing beyond it.":
    "Escribe qué cubre la reparación. Es lo que el cliente firma, y el contrato de reparación no promete nada más allá de eso.",
  "The repair could not be planned.": "No se pudo planear la reparación.",
  '"{template}" has no products on it yet — add them under Tools → Templates.':
    '"{template}" todavía no tiene productos — agrégalos en Herramientas → Plantillas.',
  'Nothing on "{template}" applies to the build you described.':
    'Nada de "{template}" aplica a la construcción que describiste.',
  "the rest of the roof": "el resto del techo",
  "{material} supplier": "Proveedor de {material}",
  "Tick the packages to generate.": "Marca los paquetes a generar.",
  "Check before the material order is sent:":
    "Revisa antes de enviar la orden de materiales:",
  "Created {n} estimate(s).": "Se crearon {n} presupuesto(s).",
  "({n} package(s) were created before this.)":
    "({n} paquete(s) se crearon antes de esto.)",
  "Create Estimate": "Crear presupuesto",
  "Start from nothing, or build it from the roof measurements.":
    "Empieza desde cero, o ármalo con las medidas del techo.",
  "Create From Scratch": "Crear desde cero",
  "An empty estimate. Add the line items yourself.":
    "Un presupuesto vacío. Agrega tú mismo las líneas.",
  "Create From Measurements": "Crear desde las medidas",
  "Pick a template and the quantities come off the roof, with the material and work orders written for you.":
    "Elige una plantilla y las cantidades salen del techo, con la orden de materiales y la orden de trabajo ya escritas.",
  "Type the scope of work and the price. No template, no measurements — the repair contract goes on it.":
    "Escribe el alcance del trabajo y el precio. Sin plantilla, sin medidas — lleva el contrato de reparación.",
  "What the customer reads, in your words. Everything else can be added afterwards.":
    "Lo que el cliente lee, en tus palabras. Todo lo demás se puede agregar después.",
  "A repair trade is what puts the repair contract on the document, and keeps the permit and the manufacturer warranty off the price.":
    "Un oficio de reparación es lo que pone el contrato de reparación en el documento, y deja el permiso y la garantía del fabricante fuera del precio.",
  "What is wrong, what we will do about it, what is included and what is not.":
    "Qué está mal, qué vamos a hacer al respecto, qué incluye y qué no.",
  "What the customer pays. Change it, or add more lines, on the estimate afterwards.":
    "Lo que paga el cliente. Cámbialo, o agrega más líneas, en el presupuesto después.",
  "Generate from the roof measurements": "Generar con las medidas del techo",
  "Take measurements": "Tomar medidas",
  "Tick at least one package first": "Marca al menos un paquete primero",
  "Generating {name}…": "Generando {name}…",
  "Generate {n} Estimates": "Generar {n} presupuestos",
  "Generate Estimate": "Generar presupuesto",
  "This job has no roof measurements yet.":
    "Este trabajo todavía no tiene medidas del techo.",
  "This job has no wall measurements yet.":
    "Este trabajo todavía no tiene medidas de paredes.",
  "A siding estimate needs the walls measured — from the Hover report, or keyed in — to work the quantities out from.":
    "Un presupuesto de revestimiento necesita las paredes medidas — del reporte de Hover, o escritas a mano — para calcular las cantidades.",
  "An estimate generated from measurements needs a measured roof to work the quantities out from.":
    "Un presupuesto generado con medidas necesita un techo medido para calcular las cantidades.",
  "Take them on the Wall Measurements card, then come back here.":
    "Tómalas en la tarjeta Medidas de paredes y luego vuelve aquí.",
  "Take them on the Roof Measurements card, then come back here.":
    "Tómalas en la tarjeta Medidas del techo y luego vuelve aquí.",
  "Take them on the Wall Measurements card first.":
    "Tómalas primero en la tarjeta Medidas de paredes.",
  "Take them on the Roof Measurements card first.":
    "Tómalas primero en la tarjeta Medidas del techo.",
  "Also generating: {names}.": "También se generan: {names}.",
  "Labor only": "Solo mano de obra",
  'The customer buys the materials. No material order is written, and the scope starts "{heading}". The package\'s warranty and wording stay as they are.':
    'El cliente compra los materiales. No se escribe orden de materiales, y el alcance empieza con "{heading}". La garantía y el texto del paquete se quedan igual.',
  "Measuring from {layouts} — {squares} squares in total, {waste}% waste.":
    "Midiendo de {layouts} — {squares} cuadros en total, {waste}% de desperdicio.",
  "Measuring from {walls} — {squares} squares of siding and trim, {waste}% waste.":
    "Midiendo de {walls} — {squares} cuadros de revestimiento y molduras, {waste}% de desperdicio.",
};
